import { collection } from 'firebase/firestore';
import { db } from '../../lib/firebase';
import { deleteThreadTempFiles } from './threadTempApi';

export type ThreadTempFileDoc = {
  id: string; // attachmentId
  threadId: string;
  // 保存先（追記post / comment）
  targetType: 'post' | 'comment';
  targetId: string;
  // legacy: 旧実装では postId のみ
  postId?: string;
  fileName: string;
  mimeType: string;
  size: number;
  storagePath: string;
  downloadURL: string;
  expiresAt: any;
  createdAt: any;
  createdBy: string;
  updatedAt: any;
  updatedBy: string;
  isDeleted?: boolean;
  deletedAt?: any;
  deletedBy?: string;
};

export const threadTempFilesCollectionRef = (workspaceId: string) =>
  collection(db, `workspaces/${workspaceId}/threadTempFiles`);

/**
 * 一時ファイルを削除する（Storage・一覧 index・スレッド側表示・使用量の更新はサーバーで実施）。
 * index の作成・更新はクライアントからは行えない（Rules で禁止）。作成は reserveThreadTempUploadFn が行う。
 * 削除済み・存在しない場合は null。
 */
export const deleteThreadTempFileByAttachmentId = async (args: {
  workspaceId: string;
  attachmentId: string;
  userId?: string;
}): Promise<{ attachmentId: string } | null> => {
  const { workspaceId, attachmentId } = args;
  const r = await deleteThreadTempFiles({ workspaceId, attachmentIds: [attachmentId] });
  if (r.failed.includes(attachmentId)) throw new Error('failed to delete temporary file');
  return r.deleted.includes(attachmentId) ? { attachmentId } : null;
};
